"use client";

/**
 * ClueWrapper for the /[tenant]/campaigns/[slug]/locations/[location-slug] route pattern.
 *
 * This is a thin wrapper that re-exports the shared ClueWrapper component
 * with the 'tenant-campaign' route pattern configuration.
 */

import { ClueWrapper as SharedClueWrapper, ClueWrapperProps } from "@/components/clue";

// Re-export the props type for backwards compatibility
export type { ClueWrapperProps };

export function ClueWrapper(props: ClueWrapperProps) {
  return <SharedClueWrapper {...props} routePattern="tenant-campaign" />;
}
